import injectBanner from './inject-banner';
import getBannerData from './get-banner-data';
import injectMultipleBanners from './inject-multiple-banners';

export default function injectBannersToEntities(entities, { banner, ...options }) {
  if (!entities.length) return [];

  const { repeat } = banner;
  const bannerData = getBannerData(banner, options);

  const entitiesWithBanner = repeat
    ? injectMultipleBanners(entities, bannerData)
    : injectBanner(entities, bannerData);

  return entitiesWithBanner;
}
